import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import {
  BackgroundImage,
  Row, Button,
} from './Styles';
import Header from '../../../../../Common/Header';
import { checkBigGreen, checkGreen } from '../../../../../../../assets/Base64Image';
import { getFoodifoxData, updateFoodifoxData } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import ProblemReportModal from '../../../../../Common/ProblemReportModal';
import NoFreeBoxModal from '../../../../../Common/NoFreeBoxModal';
import Logo from '../../../../../Common/Logo';
import ReopenButton from '../../../../../Common/ReopenButton';
import { Box, Order } from '../../../../../../../lib/types';
import { getCabId32Str } from '../../../../../../../lib/utils/utils';
import OpenedBox from '../../../../../Common/OpenedBox/User';

const OpenBoxSuccess: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  userId,
  roomNo,
  platform,
  orderId,
  setSelectedPlatform,
  openedBoxes,
}) => {
  const [reopenBoxLazy, { loading: reopenLoading }] = updateFoodifoxData('/foxH5Take/reopenBoxByRoomNo');
  const [saveReasonLazy, { loading: saveReasonLoading }] = updateFoodifoxData('/foxH5RentLog/saveCannotUseCabReason');
  const { data: orderData, loading: getOrderDataLoading } = getFoodifoxData<Order>('/foxWebH5Order/getById?orderId=' + orderId);
  const { data: orderDateData, loading: checkSaveTimeLoading } = getFoodifoxData<{ takeDate: string }>('/foxH5Check/getOrderSaveCabDate', { orderId });

  const timeWaitRef = useRef<number>();

  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();
  const [timeWait, setTimeWait] = useState<string>();
  const [showProblemModal, setShowProblemModal] = useState<boolean>(false);

  useEffect(() => {
    setShowLoading(reopenLoading || checkSaveTimeLoading || saveReasonLoading || getOrderDataLoading);

    return () => {
      setShowLoading(false);
    };
  }, [reopenLoading, checkSaveTimeLoading, saveReasonLoading, getOrderDataLoading]);

  useEffect(() => {
    if (orderDateData && orderDateData.takeDate) {
      const time = 60 - (new Date().getTime() - new Date(orderDateData.takeDate.replace(/-/g, '/')).getTime()) / 1000;
      timeWaitRef.current = time < 0 ? 0 : time;
      setTimeWait(timeWaitRef.current.toFixed(0));
    }
  }, [orderDateData]);

  useEffect(() => {
    setInterval(() => {
      if (timeWaitRef.current != null && timeWaitRef.current <= 1) {
        timeWaitRef.current = 0;
        setTimeWait('0');
        return;
      }
      if (timeWaitRef.current != null && timeWaitRef.current > 1) {
        timeWaitRef.current -= 1;
        setTimeWait(timeWaitRef.current.toFixed(0));
      }
    }, 1000);
  }, []);

  /**
   * 重新开柜门
   */
  const reopenBox = () => {
    // 超过1分钟后，需要去到重新开门页面
    if (timeWaitRef.current == null || timeWaitRef.current <= 0) {
      setSelectedPlatform(undefined);
      setTargetPage('platform-select-reopen-box');
      return;
    }

    if (orderData) {
      reopenBoxLazy({
        param: {
          cabId: getCabId32Str(orderData.useCabId),
          roomNo,
          userId,
          platform,
        },
      });
    }
  };

  return (
    <BackgroundImage>
      {
        showProblemModal && (
          <ProblemReportModal
            onClose={() => setShowProblemModal(false)}
            onConfirm={(reason) => {
              if (orderData) {
                setShowProblemModal(false);
                saveReasonLazy({
                  param: {
                    cabId: getCabId32Str(orderData.useCabId),
                    boxNumbers: JSON.stringify(openedBoxes.map((box) => box.boxNumber)),
                    reportUser: 'Recipient',
                    userId,
                    reason,
                    orderId,
                  },
                });
              }
            }}
            isEnglish={isEnglish}
            optionKeys={['Dirty', 'Door is not working', 'Other']}
          />
        )
      }
      {
        showNoFreeBoxModal && (
          <NoFreeBoxModal onClose={() => setShowNoFreeBoxModal(false)} isEnglish={isEnglish} />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
        showSupport={false}
        showHome={true}
      />

      {/* Logo */}
      <Logo showBackIcon={false} />

      {/* 描述 */}
      {
        isEnglish ? (
          <Row style={{ margin: '43px auto 0 auto', justifyContent: 'center' }}>
            {/* Check图标 */}
            <img src={checkBigGreen} style={{ width: '25px', height: '25px' }} />
            <div style={{ fontSize: '22px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '30px', marginLeft: '8px' }}>
              Successful!
            </div>
          </Row>
        ) : (
          <div style={{ margin: '43px auto 0 auto', textAlign: 'center', width: '232px', fontSize: '22px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 500, color: '#11202B', lineHeight: '30px' }}>
            开柜成功!
          </div>
        )
      }

      {
        openedBoxes.map((box) => (
          <OpenedBox
            key={box.boxNumber}
            width={335}
            boxNumber={box.boxNumber}
            isEnglish={isEnglish}
            cabSizeType={box.cabSizeType}
            lockAddress={box.lockNumber}
            lockPort={box.lockPort}
            style={{
              margin: '21px auto 21px auto',
              textAlign: 'center',
              background: '#FFFFFF',
              borderRadius: '20px',
              border: '1px solid rgba(17,32,43,0.1)',
            }}
          />
        ))
      }

      {/* 重新打开柜门、反馈 */}
      <div style={{ width: '335px', margin: '21px auto 50px auto', padding: '25px 0', textAlign: 'center', background: '#FFFFFF', borderRadius: '20px', border: '1px solid rgba(17,32,43,0.1)' }}>
        <Row style={{ justifyContent: 'space-between' }}>
          {/* 重新打开柜门 */}
          <ReopenButton
            onClick={() => reopenBox()}
            isEnglish={isEnglish}
            timeWait={timeWait}
            style={{ marginLeft: '19px' }}
          />

          {/* 不能使用柜门，弹出反馈窗口，然后重新打开新柜门 */}
          <Button
            onClick={() => setShowProblemModal(true)}
            style={{ width: '140px', height: '47px', background: '#D0D0D0', borderRadius: '23px', marginRight: '19px' }}>
            {
              isEnglish ? (
                <div style={{ fontSize: '14px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '19px' }}>
                  Report problems
                </div>
              ) : (
                <div style={{ fontSize: '14px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '20px' }}>
                  反馈柜子问题
                </div>
              )
            }
          </Button>
        </Row>

        {/* 柜门信息 */}
        <Row style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
          {
            openedBoxes.map((box) => {
              return (
                <div style={{ margin: '40px auto 0 auto', width: '142px', height: '68px', background: '#F3F3F3', borderRadius: '12px', textAlign: 'center' }}>
                  <img src={checkGreen} style={{ width: '36px', marginTop: '-18px' }} />
                  {
                    isEnglish ? (
                      <div style={{ marginTop: '8px', fontSize: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '24px' }}>
                        Door #{box.boxNumber}
                      </div>
                    ) : (
                      <div style={{ marginTop: '8px', fontSize: '18px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '25px' }}>
                        柜门编号 #{box.boxNumber}
                      </div>
                    )
                  }
                </div>
              );
            })
          }
        </Row>
      </div>
      <div style={{ height: 20 }} />
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  userId: number;
  roomNo: string;
  platform: number;
  orderId: number;
  setSelectedPlatform: (platform?: number) => void;
  openedBoxes: Box[];
}

export default OpenBoxSuccess;
